import { IconAngleRight } from '../icons';
import './Header.css';

export const Header = () => {
  return (
    <div className="page">
      <header className="header">
        <div className="container mall">
          <div className="header-content">
            <h1>The Drug Patent Book</h1>
            <p className="hero-sub">Better Information, Better Decisions.</p>
            <p className="hero-text">We deserve transparency and access to the information about the drug patents impacting Americans and their healthcare. Lack of critical data on patents prevents lawmakers from making informed decisions which can help to reduce prescription drug costs.</p>
          </div>
        </div>
      </header>
      <section className="section-grid">
        <div className="container mall">
          <div className="grid">
            <div className="grid-item link">
              <img src="https://www.i-mak.org/wp-content/uploads/2022/07/illo-video.png" alt="" width="128" height="128" />
              <div className="grid-item-text">
                <h3>Learn How</h3>
                <p>Watch a quick tutorial on how to navigate our new database and build your own analyses.</p>
              </div>
              <a className="cta" href="https://www.i-mak.org/patent-methods/#learn" target="_blank" rel="noreferrer">Watch Now <IconAngleRight /></a>
            </div>
            <div className="grid-item link">
              <img src="https://www.i-mak.org/wp-content/uploads/2022/07/illo-conversation.png" alt="" width="128" height="128" />
              <div className="grid-item-text">
                <h3>Background &amp; Methods</h3>
                <p>Learn why this database was created and our patent search methodologies.</p>
              </div>
              <a className="cta" href="https://www.i-mak.org/patent-methods/" target="_blank" rel="noreferrer">Learn More <IconAngleRight /></a>
            </div>
            <div className="grid-item link">
              <img src="https://www.i-mak.org/wp-content/uploads/2022/07/illo-search.png" alt="" width="128" height="128" />
              <div className="grid-item-text">
                <h3>Data Summary</h3>
                <p>Get a comprehensive market and patent summary on America's Top Selling Drugs.</p>
              </div>
              <a className="cta" href="https://www.i-mak.org/wp-content/uploads/2026/03/i-mak-counting-the-cost-of-patents-for-high-spend-medicare-drugs-20260325.pdf" target="_blank" rel="noreferrer">View Summary <IconAngleRight /></a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
